import { render, staticRenderFns } from "./PridelavaUkazi.vue?vue&type=template&id=0f2a5f50&"
import script from "./PridelavaUkazi.vue?vue&type=script&lang=js&"
export * from "./PridelavaUkazi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports